export default __webpack_public_path__ + "static/media/fork_page.cd23906e.svg";